module.exports = __webpack_public_path__ + "static/tech-ca0c81aff6b6a0d5f257f165ffbf7626.jpg";